import React from "react"

import AboutPageMetaTagsAndOpenGraphInfo from "./Seo_metaTags_openGraph_Info"
import AboutPageStuctredDataUsingJsonLd from "./SeoStructuredData"

const Seo = () => {
  return (
    <>
      <AboutPageMetaTagsAndOpenGraphInfo />
      <AboutPageStuctredDataUsingJsonLd />
    </>
  )
}

export default Seo
